import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>அக்ஷராப்யாஸம்</h1>
<div class="div3">
  <img src="assets/img/aksharabhyasam.jpg" class="img2" />
  கைகால்கள் அலம்பிக்கொண்டு  இரண்டு ஆவர்த்தி ஆசமனம் செய்து படியில் வந்து ஸேவித்து 
    உட்காரவும். படியில் நெல் சேர்க்க வேண்டியது. 1 மரக்கால் இருந்தால்தான், எழுத்துக்கள், 
    குழந்தை விரல்களால் எழுதுவதுடன் எழுத்துக்கள் எழுதினதை அழிக்காமல் மேல் மேல் எழுதுவது 
    சௌகர்யம். அழித்து எழுதுவது பழக்கமில்லை. <br /> 
பவித்திரம் தரித்துக்கொண்டு நமஸதஸே - ஸ்ரீ வைஷ்ணவேப்யோ நம: என்று சோபனாக்ஷதையை 
ஸதஸிலுள்ளவர்கள் மேல் சேர்;த்து  அசேஷே ஆரம்பித்து ஸ்வீக்ருத்ய வரையில் சொல்லி தக்ஷpணை 
ஸமர்பித்து நக்ஷத்ரே ராசௌ ஜாதஸ்ய (மம) குமாரஸ்ய அக்ஷராப்யாஸம் கர்த்தும் யோக்யதா ஸித்திம் 
அனுக்ரஹாணா என்று ப்ராத்திக்கிறது அனுக்ரஹம் பெற்று.<br /> 
<br /> 
	படியில் உட்கார்ந்து  விஷ்வக்ஸேன ஆராதனம் செய்து, ஸ்ரீகோவிந்தேத்யாதி சுபதிதௌ (மம) குமாரஸ்ய 
    அக்ஷராப்யாஸம் கரிஷ்யே என்று ஸங்கல்பம் செய்து, விஷ்வக்ஸேநரை யதாஸ்தானம் செய்து சந்தனம், 
    புஷ்பம் முதலியன தரித்து சோபனாக்ஷதையால்; பெரியோர்கள் அனுக்ரஹம் பெறவேணும்.<br /> 
<br /> 
	ஓலைச் சுவடியை தான்யத்தின் மேல் (நெல் மேல்) வைத்து 'ஞாநாநந்த மயம்தேவம் நிர்மல ஸ்படிகாக்ருதிம் 
    ஆதாரம் ஸர்வவித்யாநாம் ஹயக்ரீவம் உபாஸ்ம ஹே" என்று ஓலைச்சுவடியில் ஹயக்ரீவரை ஆவாஹனம் 
    செய்து ஆஸனாதி ஸர்வ உபசாரங்களும் செய்து க்ரஹ ப்ரீதி செய்து, அக்ஷரங்களை சொல்லி வைத்து, நெல்லில் 
    எழுதச் சொல்லி, பிறகு மறுபடியும் சொல்லச் சொல்லுகிறது.<br /> 
<br /> 
	முதலில் ஹரி: ஓம் இந்த மம்மோ நந்நா ராரா யய்ய ணண்ணா யய்ய ஸிஸ்ஸி இத்தம் என்று சொல்லுகிறது பழக்கம் 
    பதத்தை சேர்த்துசொல்லுகிற பழக்கம்யில்லை.<br /> 
<br /> 
	அ, ஆ முதல் க்ஷ, ஷ்ப, அம், இதி: வரையில் சொல்லிக்கொடுத்து எழுதச் செய்கிறது. பிறகு ஆசீர்வாதம், ஓதியிடல்,
     ஸ்வஸ்திவாசனம், ப்ருஹஸ்பதி ஸம்பாவனை, ஸதஸ் ஸம்பாவனை செய்து, ஆலத்தி ஆனபிறகு பையனை பள்ளிக்கூடம் 
     அனுப்புகிறது, ஆசமனம், பவித்ரம் அவிழ்த்து ஆசமனம். (ஹயக்ரீ வரை யதாஸ்தானம் செய்கிற வழக்கமில்லை.)
</div>`;

const AksharaabhyaasamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="Aksharabyasam  - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default AksharaabhyaasamPage;
